import {Vat} from "./Vat";
import {Order} from "./Order";

export class OrderCustomRow {

  public id: number;
  public articleName: string;
  public amount: number;
  public price: number;
  public totalPrice: number;
  public vat: Vat | number;
  public order: Order | number;
  public orderID: number;
  public supplier: any;
}
